
  import { Component, Vue } from 'vue-property-decorator';
  import { inject } from "inversify-props";
  import '@/custom.scss';
  import { routePaths } from '@/router';
  import { types, UserInfo } from '@/store';
  import { eventBus, mcEvents } from "@/utils";
  import { Enviornments, ToastOptions } from "@/models";
  import { IMobileService } from '@/services';

    // This global and globalAny are added so we can call "pendo.initialize(...) without error about it not existing."
  declare global {
    namespace NodeJS {
      interface Global {
        document: Document;
        window: Window;
        navigator: Navigator;
      }
    }
  }

  const globalAny:any = global;

  @Component
  export default class App extends Vue {
    @inject() private readonly mobileService!: IMobileService;

    toastOptions: ToastOptions = new ToastOptions(
      'success',
      'Synced',
      'Sync Complete',
      'All pending Meal Count data has been uploaded',
      'b-toaster-top-right');

    private app: any;

    mounted() {
      eventBus.$on('syncNotice', () => {
        this.$bvToast.show('syncNoticeToast');
      });

      /// There is an issue with loggedIn event is fired more then once.
      /// Created a custom event to then be fired and remove the event after work is done.
      /// Still listen for the logged in event but firing off a new event that triggers once.
      this.app = (<any>this.$refs.app);
      this.app.addEventListener('loggedin', this.listenForLogin);
      const loggedinEvent = new Event('loggedin');
      eventBus.$on(mcEvents.loggedIn, () => {
        this.app.dispatchEvent(loggedinEvent);
          this.setupPendo();
      });
      let _this = this;


    }
    private setupPendo() {
      const user = this.$store.getters[types.state.user] as UserInfo;

      if (user)
      {
        try {
          globalAny.window.pendo.initialize({
            visitor: {
              id: user.userAuthId, // the userAuthId comes from EZ Auth Hub which is planned to be replaced with Auth0 so this might have to change later
              full_name: user.userName,
              //role: The user store does have "isSiteUser", "isSponsorUser", etc. but all of them return false? Not accessible through UserInfo also...
              first_name: user.firstName,
              last_name: user.lastName
            }
            // I think "account" info would be what State Agenc(y|ies) this user is a part of
            // and possible what Sponsor(s) they are assigned to, but we don't send that info in a clear way right now.
            // account: {
            //   id: 'OOGA-BOOGA-ACCOUNT-ID',
            //   name: 'OOGA-BOOGA-ACCOUNT',
            //   creationDate: '06-13-2022'
            // }
          });
        } catch (error) {
          if(process.env.NODE_ENV?.toUpperCase() === Enviornments.Development.toUpperCase()) {
            throw error;
          } else {
            throw Error(
              `There was an issue installing Pendo's library. https://help.pendo.io/resources/support-library/installation/single-page.html`
            );
          }
        }
      }
    }

    get isAuthenticated() {
      return this.$store.getters[types.state.isAuthenticated];
    }

    get showHeader() {
      return this.$route.path !== routePaths.home.path;
    }

    handleOfflineChange(value) {
      this.$store.dispatch(types.actions.setIsOnline, value);
    }

    private listenForLogin() {
      //this.displayPWAModal();
      this.app.removeEventListener('loggedin', this.listenForLogin);
    }
    private displayPWAModal() {
      if (process.env.NODE_ENV === 'development') {
        this.mobileService.fakeiPhone();
      }
      this.mobileService.shouldDisplayInstallNotice(() => {
        this.$bvModal.show('pwa_modal');
      });
    }
  }

  //FOR USERS NAME IN FOOTER
Vue.filter('truncate', function (text, stop, clamp) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})

